export default __webpack_public_path__ + "static/media/front.f06eb527.jpg";